// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-position {
  z-index: 10000;
  position: fixed; 
  bottom: 50px; 
  right: 0;  
}
.show-alert-position {
    z-index: 11000;
    animation: animationFrames ease 1s;
    animation-iteration-count: 1;
    transform-origin: 50% 50%;
    animation-fill-mode:forwards; /*when the spec is finished*/
    -webkit-animation: animationFrames ease 1s;
    -webkit-animation-iteration-count: 1;
    -webkit-transform-origin: 50% 50%;
    -webkit-animation-fill-mode:forwards; /*Chrome 16+, Safari 4+*/ 
    -moz-animation: animationFrames ease 1s;
    -moz-animation-iteration-count: 1;
    -moz-transform-origin: 50% 50%;
    -moz-animation-fill-mode:forwards; /*FF 5+*/
    -o-animation: animationFrames ease 1s;
    -o-animation-iteration-count: 1;
    -o-transform-origin: 50% 50%;
    -o-animation-fill-mode:forwards; /*Not implemented yet*/
    -ms-animation: animationFrames ease 1s;
    -ms-animation-iteration-count: 1;
    -ms-transform-origin: 50% 50%;
    -ms-animation-fill-mode:forwards; /*IE 10+*/;
  }
  
  @keyframes animationFrames{
    0% {
      opacity:0;
      transform:  translate(0px,-25px)  ;
    }
    100% {
      opacity:1;
      transform:  translate(0px,0px)  ;
    }
  }







  .vv-alert {
    z-index: 5;
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    /* border-radius: 4px; */
  }
  .vv-alert h4 {
    margin-top: 0;
    color: inherit;
  }
  .vv-alert .vv-alert-link {
    font-weight: bold;
  }
  .vv-alert > p,
  .vv-alert > ul {
    margin-bottom: 0;
  }
  .vv-alert > p + p {
    margin-top: 5px;
  }
  .vv-alert-dismissable,
  .vv-alert-dismissible {
    padding-right: 35px;
  }
  .vv-alert-dismissable .close,
  .vv-alert-dismissible .close {
    position: relative;
    top: -2px;
    right: -21px;
    color: inherit;
  }
  .vv-alert-success {
    color: #dff0d8;
    background-color: #3c763d;
    border-color: #d6e9c6;
  }
  .vv-alert-success hr {
    border-top-color: #c9e2b3;
  }
  .vv-alert-success .vv-alert-link {
    color: #2b542c;
  }
  .vv-alert-info {
    color: #d9edf7;
    background-color: #31708f;
    border-color: #bce8f1;
  }
  .vv-alert-info hr {
    border-top-color: #a6e1ec;
  }
  .vv-alert-info .vv-alert-link {
    color: #245269;
  }
  .vv-alert-warning {
    color: #fcf8e3;
    background-color: #8a6d3b;
    border-color: #faebcc;
  }
  .vv-alert-warning hr {
    border-top-color: #f7e1b5;
  }
  .vv-alert-warning .vv-alert-link {
    color: #66512c;
  }
  .vv-alert-danger {
    color: #f2dede;
    background-color: #a94442;
    border-color: #ebccd1;
  }
  .vv-alert-danger hr {
    border-top-color: #e4b9c0;
  }
  .vv-alert-danger .vv-alert-link {
    color: #843534;
  }
  @keyframes progress-bar-stripes {
    from {
      background-position: 40px 0;
    }
    to {
      background-position: 0 0;
    }
  }`, "",{"version":3,"sources":["webpack://./src/app/shared/directives/alert-shim/alert-shim.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,QAAQ;AACV;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,4BAA4B;IAC5B,yBAAyB;IACzB,4BAA4B,EAAE,4BAA4B;IAC1D,0CAA0C;IAC1C,oCAAoC;IACpC,iCAAiC;IACjC,oCAAoC,EAAE,wBAAwB;IAC9D,uCAAuC;IACvC,iCAAiC;IACjC,8BAA8B;IAC9B,iCAAiC,EAAE,QAAQ;IAC3C,qCAAqC;IACrC,+BAA+B;IAC/B,4BAA4B;IAC5B,+BAA+B,EAAE,sBAAsB;IACvD,sCAAsC;IACtC,gCAAgC;IAChC,6BAA6B;IAC7B,gCAAgC,EAAE,SAAS;EAC7C;;EAEA;IACE;MACE,SAAS;MACT,kCAAkC;IACpC;IACA;MACE,SAAS;MACT,gCAAgC;IAClC;EACF;;;;;;;;EAoDA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,cAAc;EAChB;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EAiBA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF","sourcesContent":[".alert-position {\n  z-index: 10000;\n  position: fixed; \n  bottom: 50px; \n  right: 0;  \n}\n.show-alert-position {\n    z-index: 11000;\n    animation: animationFrames ease 1s;\n    animation-iteration-count: 1;\n    transform-origin: 50% 50%;\n    animation-fill-mode:forwards; /*when the spec is finished*/\n    -webkit-animation: animationFrames ease 1s;\n    -webkit-animation-iteration-count: 1;\n    -webkit-transform-origin: 50% 50%;\n    -webkit-animation-fill-mode:forwards; /*Chrome 16+, Safari 4+*/ \n    -moz-animation: animationFrames ease 1s;\n    -moz-animation-iteration-count: 1;\n    -moz-transform-origin: 50% 50%;\n    -moz-animation-fill-mode:forwards; /*FF 5+*/\n    -o-animation: animationFrames ease 1s;\n    -o-animation-iteration-count: 1;\n    -o-transform-origin: 50% 50%;\n    -o-animation-fill-mode:forwards; /*Not implemented yet*/\n    -ms-animation: animationFrames ease 1s;\n    -ms-animation-iteration-count: 1;\n    -ms-transform-origin: 50% 50%;\n    -ms-animation-fill-mode:forwards; /*IE 10+*/;\n  }\n  \n  @keyframes animationFrames{\n    0% {\n      opacity:0;\n      transform:  translate(0px,-25px)  ;\n    }\n    100% {\n      opacity:1;\n      transform:  translate(0px,0px)  ;\n    }\n  }\n  \n  @-moz-keyframes animationFrames{\n    0% {\n      opacity:0;\n      -moz-transform:  translate(0px,-25px)  ;\n    }\n    100% {\n      opacity:1;\n      -moz-transform:  translate(0px,0px)  ;\n    }\n  }\n  \n  @-webkit-keyframes animationFrames {\n    0% {\n      opacity:0;\n      -webkit-transform:  translate(0px,-25px)  ;\n    }\n    100% {\n      opacity:1;\n      -webkit-transform:  translate(0px,0px)  ;\n    }\n  }\n  \n  @-o-keyframes animationFrames {\n    0% {\n      opacity:0;\n      -o-transform:  translate(0px,-25px)  ;\n    }\n    100% {\n      opacity:1;\n      -o-transform:  translate(0px,0px)  ;\n    }\n  }\n  \n  @-ms-keyframes animationFrames {\n    0% {\n      opacity:0;\n      -ms-transform:  translate(0px,-25px)  ;\n    }\n    100% {\n      opacity:1;\n      -ms-transform:  translate(0px,0px)  ;\n    }\n  }\n\n\n\n\n\n\n\n  .vv-alert {\n    z-index: 5;\n    padding: 15px;\n    margin-bottom: 20px;\n    border: 1px solid transparent;\n    /* border-radius: 4px; */\n  }\n  .vv-alert h4 {\n    margin-top: 0;\n    color: inherit;\n  }\n  .vv-alert .vv-alert-link {\n    font-weight: bold;\n  }\n  .vv-alert > p,\n  .vv-alert > ul {\n    margin-bottom: 0;\n  }\n  .vv-alert > p + p {\n    margin-top: 5px;\n  }\n  .vv-alert-dismissable,\n  .vv-alert-dismissible {\n    padding-right: 35px;\n  }\n  .vv-alert-dismissable .close,\n  .vv-alert-dismissible .close {\n    position: relative;\n    top: -2px;\n    right: -21px;\n    color: inherit;\n  }\n  .vv-alert-success {\n    color: #dff0d8;\n    background-color: #3c763d;\n    border-color: #d6e9c6;\n  }\n  .vv-alert-success hr {\n    border-top-color: #c9e2b3;\n  }\n  .vv-alert-success .vv-alert-link {\n    color: #2b542c;\n  }\n  .vv-alert-info {\n    color: #d9edf7;\n    background-color: #31708f;\n    border-color: #bce8f1;\n  }\n  .vv-alert-info hr {\n    border-top-color: #a6e1ec;\n  }\n  .vv-alert-info .vv-alert-link {\n    color: #245269;\n  }\n  .vv-alert-warning {\n    color: #fcf8e3;\n    background-color: #8a6d3b;\n    border-color: #faebcc;\n  }\n  .vv-alert-warning hr {\n    border-top-color: #f7e1b5;\n  }\n  .vv-alert-warning .vv-alert-link {\n    color: #66512c;\n  }\n  .vv-alert-danger {\n    color: #f2dede;\n    background-color: #a94442;\n    border-color: #ebccd1;\n  }\n  .vv-alert-danger hr {\n    border-top-color: #e4b9c0;\n  }\n  .vv-alert-danger .vv-alert-link {\n    color: #843534;\n  }\n  @-webkit-keyframes progress-bar-stripes {\n    from {\n      background-position: 40px 0;\n    }\n    to {\n      background-position: 0 0;\n    }\n  }\n  @-o-keyframes progress-bar-stripes {\n    from {\n      background-position: 40px 0;\n    }\n    to {\n      background-position: 0 0;\n    }\n  }\n  @keyframes progress-bar-stripes {\n    from {\n      background-position: 40px 0;\n    }\n    to {\n      background-position: 0 0;\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
